/* eslint-disable react-hooks/rules-of-hooks */
import { LoadingLayout } from 'components';
import { useGetNavigateSearchParams } from 'hooks';
import { usePageTitle } from 'libs/navigation';
import { NotFound } from 'modules/App/NotFound';
import { useDirectories } from 'modules/order/common/hooks';

import { getOrderTypeBySearchParams } from '../helpers/getOrderTypeBySearchParams';
import { useCreateOrder } from '../hooks';
import { CreateOrderProvider } from '../providers/OrderProvider';
import { CreateOrderView } from '../views/CreateOrderView';

export const CreateOrderContainer = () => {
  const { type: searchParamOrderType } = useGetNavigateSearchParams(['type']);

  const orderType = getOrderTypeBySearchParams(searchParamOrderType);

  if (!orderType) {
    return <NotFound />;
  }

  const {
    initialValues,
    disabledDates,
    submitLoading,
    loading,
    orderSchema,
    minEndDate,
    title,
    breadcrumbsTitles,
    brokerTimezoneOffset,
    onBack,
    onSubmit,
  } = useCreateOrder({ orderType });

  const {
    loading: directoriesLoading,
    directories,
    schemas,
  } = useDirectories({
    orderSchema,
  });

  usePageTitle(title);

  if (loading || directoriesLoading) {
    return <LoadingLayout />;
  }

  return (
    <CreateOrderProvider
      brokerTimezoneOffset={brokerTimezoneOffset}
      directories={directories}
      disabledDates={disabledDates}
      minEndDate={minEndDate}
      orderType={orderType}
      schemas={schemas}
    >
      <CreateOrderView
        breadcrumbsTitles={breadcrumbsTitles}
        initialValues={initialValues}
        submitLoading={submitLoading}
        title={title}
        onBack={onBack}
        onSubmit={onSubmit}
      />
    </CreateOrderProvider>
  );
};
